// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "mainSite." + {"121":"gallery","179":"main"}[chunkId] + "." + {"121":"d7a8355aee0001adce92","179":"fc5ebfd475df92ffe5f1"}[chunkId] + ".css";
};